import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/app-shared/src/public-api';
import { EcommerceGenericoService } from 'projects/ecommerce-generico/src/public-api';

@Component({
  selector: 'modal-medio-pago',
  templateUrl: './modal-medio-pago.component.html',
  styleUrls: ['./modal-medio-pago.component.scss']
})

export class ModalMedioPagoComponent implements OnInit {

  constructor(private modal: ModalService, private genServ : EcommerceGenericoService) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-medio-pago');
  }

  get medioPago(){
    return this.genServ.getinfoMP()
  }

  get errorMessage() {
    return this.genServ.getErrorMessage();
  }

}
